module.exports = __webpack_public_path__ + "img/rolling-stones.fe86e4c8.jpg";